/* eslint-disable no-param-reassign */
import { createSlice, SliceCaseReducers, ValidateSliceCaseReducers } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { Store } from '@sv-support-sdk/shared-types';

type TModalState = Store.Modals.IModalsState;

export const initialState: TModalState = {
  openedModals: [],
};

const modalsSlice = <T extends TModalState, Reducers extends SliceCaseReducers<T>>({
  name = 'modals',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) =>
  createSlice({
    name,
    initialState,
    reducers: {
      openModal(state, action: PayloadAction<{ name: string; props?: { [key: string]: any } }>) {
        const isModalOpened = state.openedModals.some(({ name }) => name === action.payload.name);

        if (!isModalOpened) {
          state.openedModals.push(action.payload);
        }
      },
      closeModal(state, action: PayloadAction<string>) {
        state.openedModals = state.openedModals.filter(({ name }) => name !== action.payload);
      },
      ...reducers,
    },
  });

export default modalsSlice;
